import { render, staticRenderFns } from "./selected-recipients.vue?vue&type=template&id=15868189&"
import script from "./selected-recipients.vue?vue&type=script&lang=js&"
export * from "./selected-recipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports